import { Form } from "antd";
import AppContent from "common/AppContent";
import AppPageHeader from "common/PageHeader";
import ExtraContent from "components/Configuration/CommonComponents/ExtraContent";
import { useState } from "react";
import { SEWING_CREATE_PERMISSION } from "routes/permissions";
import { hasPermission } from "utils/functions";
import SewingForm from "../SewingForm";

const SewingCreate = () => {
  // Antd
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = () => {
    form.submit();
  };

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                handleAddItemOpen={onSubmit}
                disabled={
                  !hasPermission([SEWING_CREATE_PERMISSION]) || isSubmitting
                }
                addButtonText={
                  hasPermission([SEWING_CREATE_PERMISSION])
                    ? "Submit"
                    : "No Permission"
                }
                hideFilterButton
                showBackButton
              />
            }
            title="Create Sewing"
          />
        }
        content={
          <>
            <SewingForm form={form} setIsSubmitting={setIsSubmitting} />
          </>
        }
      />
    </>
  );
};

export default SewingCreate;
